import { m } from "@/paraglide/messages";
import type { Tool } from "../index";

export const statisticsCalculatorTool: Tool = {
  id: "statistics-calculator",
  name: () => m.st_tool_name(),
  description: () => m.st_tool_description(),
  icon: "📈",
  basePath: "/statistics-calculator",
  status: "stable",
  tags: ["education", "math", "statistics", "statistics-calculator"],
};
